import { render, staticRenderFns } from "./BuildingPlanDetails.vue?vue&type=template&id=841363a6"
import script from "./BuildingPlanDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./BuildingPlanDetails.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports